import { render, staticRenderFns } from "./u-tooltip-opacity-rounded-lg.vue?vue&type=template&id=dd79d5f0&scoped=true&"
import script from "./u-tooltip-opacity-rounded-lg.vue?vue&type=script&lang=js&"
export * from "./u-tooltip-opacity-rounded-lg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd79d5f0",
  null
  
)

export default component.exports